<template>
    <div class="cancelplan-root">
        <div class="root-container" v-if="showContent">
            <div class="content-top">
                <h1 >{{ $t('cancel_plan.title', {
                    planname: sub.plan.title
                }) }}</h1>
            </div>
            <steps :stepsData="stepsData" :stepsIndex="highLight" class="step-com"></steps>

            <div class="step-one">
                <div class="middle-content">
                    <p class="package">{{ $t('cancel_plan.plan_details') }}</p>
                    <plan-message :list="message" class="plan-message" v-if="sub.plan"></plan-message>
                </div>
                <p class="package" v-if="mode!=='traffic'">{{ $t('cancel_plan.are_you_sure') }}</p>
                <p class="package" v-else>{{ $t('cancel_plan.traffic.are_you_sure') }}</p>

                <div class="middle-before" v-if="sub.plan">
                    <p class="package canc-plan">
                        <span class="benefit"> &bull;</span>
                        <span v-html="$t('cancel_plan.take_effect')"></span>
                    </p>
                    <template v-if="mode!=='traffic'">
                        <p class="package canc-plan">
                            <span class="benefit">&bull;</span>
                            <span v-html="$t('cancel_plan.before_cancel')"></span>
                        </p>
                        <section class="benefit-box">
                            <p v-if="notRichPlan" class="info-grey three-service"><span>&bull;</span> &nbsp; <span v-html="$options.filters.planHistory(sub.plan)"></span>
                            </p>
                            <p class="info-grey three-service"><span>&bull;</span> &nbsp; <span v-html="$options.filters.planCamera(sub.plan)"></span></p>
                            <p v-if="notRichPlan" class="info-grey three-service"><span>&bull;</span> &nbsp; <span v-html="$options.filters.planCapacity(sub.plan)"></span></p>
                            <p class="info-grey three-service" v-if='$options.filters.planRichNotification(sub.plan)'><span>&bull;</span> &nbsp; <span v-html="$options.filters.planRichNotification(sub.plan)"></span></p>
                        </section>
                        <p class="package canc-plan" style="margin:0" v-if="notRichPlan">
                            <span class="benefit">&bull;</span>
                            <span v-html="$t('cancel_plan.two_week_clean')"></span>
                        </p>
                    </template>
                    <template v-else>
                        <p class="package canc-plan">
                            <span class="benefit">&bull;</span>
                            <span>{{$t('cancel_plan.traffic.after_cancel')}}</span>
                        </p>
                    </template>

                </div>
                <div class='middle-cancel-ways' v-if="refundArr.length>0">
                    <p class="package">{{$t('cancel_plan.select_cancel_way')}}</p>
                    <section class="reasons-box">
                        <div class="choose-checkbox">
                            <reo-radio class="circle"
                                type="circle"
                                size="small"
                                v-model="cancelWay"
                                label="refund">
                                <span class="info-grey">{{$t('cancel_plan.cancel_way_1')}}</span>
                            </reo-radio>
                        </div>
                    </section>
                </div>
                <div class="middle-reasons">
                    <p class="package" v-if="mode!=='traffic'">{{ $t('cancel_plan.cancel_reason') }}</p>
                    <p class="package" v-else>{{ $t('cancel_plan.traffic.cancel_reason') }}</p>
                    <section class="reasons-box">
                        <template v-if="mode!=='traffic'">
                            <div class="choose-checkbox">
                                <reo-radio class="circle"
                                    type="circle"
                                    size="small"
                                    v-model="downloadOne"
                                    label="I want to switch my plan.">
                                    <span class="info-grey">{{$t('cancel_plan.reason_first')}}</span>
                                    <router-link class="ui-link" :to='switchPlanPath' v-if="switchable">
                                        <span class="text">{{ $t('cancel_plan.switch_plan')}}</span><span class="ui-icon icon-icon_arrow-right"></span>
                                    </router-link>
                                </reo-radio>
                            </div>
                            <div class="choose-checkbox" v-if="notRichPlan">
                                <reo-radio class="circle"
                                    type="circle"
                                    size="small"
                                    v-model="downloadOne"
                                    label="I prefer the local storage.">
                                    <span class="info-grey">{{$t('cancel_plan.reason_second')}}</span>
                                </reo-radio>
                            </div>
                        </template>
                        <template v-else>
                            <div class="choose-checkbox">
                                <reo-radio class="circle"
                                    type="circle"
                                    size="small"
                                    v-model="downloadOne"
                                    label="I will no longer use the relevant devices.">
                                    <span class="info-grey">{{$t('cancel_plan.traffic.reason_one')}}</span>
                                </reo-radio>
                            </div>
                        </template>

                        <div class="choose-checkbox">
                            <reo-radio class="circle"
                                type="circle"
                                size="small"
                                v-model="downloadOne"
                                label="My Current plan is expensive.">
                                <span class="info-grey">{{$t('cancel_plan.reason_third')}}</span>
                            </reo-radio>
                        </div>
                        <div class="choose-checkbox">
                            <reo-radio class="circle"
                                type="circle"
                                size="small"
                                v-model="downloadOne"
                                label="Failed to connect my camera to this plan.">
                                <span class="info-grey">{{$t('cancel_plan.reason_fifth')}}</span>
                            </reo-radio>
                        </div>
                        <div class="choose-checkbox">
                            <reo-radio class="circle"
                                type="circle"
                                size="small"
                                v-model="downloadOne"
                                label="The plan is not available for my current camera.">
                                <span class="info-grey">{{$t('cancel_plan.reason_sixth')}}</span>
                            </reo-radio>
                        </div>
                        <div class="choose-checkbox">
                            <reo-radio class="circle"
                                type="circle"
                                size="small"
                                v-model="downloadOne"
                                label="Other.">
                                <span class="info-grey">{{$t('cancel_plan.reason_forth')}}</span>
                            </reo-radio>
                        </div>
                    </section>
                </div>
                <div class="middle-text">
                    <p
                        v-if="mode!=='traffic'"
                        v-html="$t('cancel_plan.notice', lang, {
                            link: config.support_team
                        })"
                    ></p>
                    <p
                        v-else
                        v-html="$t('cancel_plan.traffic.notice', lang, {
                            link: config.support_team
                        })"
                    ></p>
                </div>
                <div class="check-ok">
                    <reo-checkbox  class="check-box"
                        v-model="sureSend"
                        size="small"
                        :isRound="false"></reo-checkbox>
                    <span class="red">*</span>
                    <span>{{ $t('cancel_plan.got_it') }}</span>
                </div>
                <div class="button-box">
                    <reo-common-button
                        to="/user/dashboard/"
                        :label="$t('cancel_plan.no_keep')"
                    />
                    <reo-common-button
                        @click="continueCancel"
                        :disabled="isCanceling"
                        :label="$t('cancel_plan.yes_cancel')"
                        color-type="light"
                    />
                </div>
            </div>
        </div>
        <InputPaypal
            v-model="showPaypalDialog"
            @confirmInputPaypal="confirmInputPaypal"
        />
        <reo-dialog
            v-if="dialogConfirmShow"
            class="paypal-dialog confirm"
            ref="confirmDialog"
            :labelOfConfirm="$t('cancel_plan.confirm')"
            :labelOfCancel="$t('cancel_plan.cancel')"
            @confirm="continueCancel"
            @cancel="cancel"
            @dialogMounted='dialogMounted'
            @dialogDestroyed="dialogDestroyed">
            <template v-slot:top>
                <h3 class='paypal-dialog-title'>{{$t('cancel_plan.confirm_dialog_title')}}</h3>
            </template>
            <template v-slot:model-show-des>
                <div class='paypal-dialog-container'>
                    <div class='paypal-dialog-note confirm'>
                        <div class='note'>{{$t('cancel_plan.paypal_account_note1')}}</div>
                        <div class='note'>{{$t('cancel_plan.paypal_account_note2')}}</div>
                    </div>
                    <div class="paypal-dialog-inner">
                        <section class="reasons-box">
                            <div class="account-box" v-if='cancelMethod==="Paypal"'>
                                <div v-for="(item, key) in paypalDetails" :key="key" :name="key" >
                                    <label for='payerAccount'><span class='warn-tips red'>* </span>{{item.placeholder}}: </label>
                                    <span class="value">{{item.value}}</span>
                                </div>
                            </div>

                            <!-- <div class="account-box" v-if='cancelMethod==="Payoneer"'>
                                <div v-for="(item, key) in payoneerDetails" :key="key" :name="key" >
                                    <label for='payerAccount'><span class='warn-tips red'>* </span>{{item.placeholder}}: </label>
                                    <span class="value">{{item.value}}</span>
                                </div>
                            </div> -->
                        </section>
                    </div>
                </div>
            </template>
            <template v-slot:note>
                <p class='warning-tip confirm'><span class='warn-tips red'>* </span>{{$t('cancel_plan.warning_tip')}}</p>
            </template>
        </reo-dialog>
        <reo-dialog
            class='associatedDevices'
            title='Associated Devices'
            v-if='isShowAssociatedDevices'
            @cancel='isShowAssociatedDevices=false'
            @dialogMounted='dialogMounted'
            @dialogDestroyed="dialogDestroyed">
            <select-product
                tableLoc="associated"
                key="associatedDevices"
                :deviceData='subDeviceDataShow'>
            </select-product>
        </reo-dialog>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import nprogress from 'nprogress';
import { config } from 'CONFIG';
import reoCheckbox from '@/basic/Checkbox.vue';
import reoRadio from '@/basic/Radio.vue';
import steps from '@/basic/Steps.vue';
import planMessage from '@/components/planMessage.vue';
import ReoDialog from '@/basic/Dialog.vue';
import SelectProduct from '@/components/selectProduct.vue';
import { deliver as deliverStatus } from '@/config/status';
import { unfoldError } from '@/common/js/notice';
import { IPlanMessage } from '@/interface';
import {
    previewRefundInfo,
    transferSubscription,
    deleteTrafficProduct,
    previewTrafficRefundInfo
} from '@/api/plan';
import { getDeviceTotal, getUserUsage } from '@/api/cloud';
import { getSubscriptionById, getSubscriptions, deleteProduct } from '@/api/subscriptions';
import { getCloudProductLists, getPlanById, getTrafficById } from '@/api/cart';
import { AxiosError } from 'axios';
import { ESeriesCategory } from '@reolink-cloud/interface';
import InputPaypal from '@/components/InputPaypal.vue';
import { Optimization } from '@reolink-web/utils';

export default Vue.extend({

    data () {

        return {
            prevSubId: this.$route.query.ps_id as string,
            plan_id: this.$route.query.p_id as string,
            traffic_package_id: this.$route.query.traffic_package_id as string,
            trafficPlanId: this.$route.query.traffic_plan_id as string,
            mode: this.$route.query.mode,
            cloudProductLists: {} as Record<string, any>,
            downloadOne: '',
            cancelWay: 'refund',
            sureSend: false,
            address: this.$store.state.user.user.email.address,
            sub: {} as Record<string, any>,
            refundArr: [] as any[],
            chooseRadioObj: {} as Record<string, any>,
            stepsData: [
                {
                    name: '1',
                    value: 1
                },
                {
                    name: '2',
                    value: 2
                }
            ],
            switchable: false,
            showContent: false,
            showPaypalDialog: false,
            dialogConfirmShow: false,
            showTips: false,
            loading: false,
            carouselItems: 2,
            planList: [] as any[],
            nextSubId: 0,
            nextSub: {} as Record<string, any>,
            transferableSub: [] as any[],
            dialogStack: [] as any[],
            deviceList: [] as any[],
            isShowAssociatedDevices: false,
            subDeviceDataShow: [] as any[],
            config,
            cancelMethod: '',
            paypalDetails: {
                payerAccount: {
                    value: '',
                    placeholder: this.$t( 'cancel_plan.paypal_account' ),
                    required: true,
                    half: false,
                    autocomplete: 'paypal-account',
                    error: false
                }
            },
            payoneerDetails: {
                payoneerName: {
                    value: '',
                    placeholder: this.$t( 'cancel_plan.payoneer_name' ),
                    required: true,
                    half: false,
                    autocomplete: 'payoneer-name',
                    error: false
                },
                payoneerCard: {
                    value: '',
                    placeholder: this.$t( 'cancel_plan.payoneer_card' ),
                    required: true,
                    half: false,
                    autocomplete: 'payoneer-cardNum',
                    error: false
                }
            },
            isCanceling: false
        };

    },

    components: {

        reoCheckbox,
        reoRadio,
        steps,
        planMessage,
        ReoDialog,
        SelectProduct,
        InputPaypal
    },

    async created () {

        if ( this.mode === 'traffic' ) {

            await this.initTraffic();

        } else {

            await this.initPlan();

        }
        nprogress.done();
        this.continueCancel = Optimization.debounce( this.continueCancel, 300 ).bind( this );

    },
    methods: {
        async continueCancel (): Promise<void> {

            let sub = this.sub;
            let isTraffic = this.mode === 'traffic';
            if ( !isTraffic && sub.status === 'inactive' ) {

                unfoldError( 'errors.plan_not_available' );

            } else if ( !isTraffic && ( sub.status === deliverStatus.PENDING || sub.status === deliverStatus.PROCESSING )) {

                unfoldError( 'errors.sub_processing' );

            } else if ( !this.sureSend || !this.downloadOne ) {

                unfoldError( 'errors.checkbox_required' );

            } else {

                if ( this.cancelWay === 'transfer' ) {

                    let planData: Record<string, any> = {};
                    planData.productId = this.nextSub.plan.id;
                    planData.qty = 0;
                    planData.context = {
                        action: 'transfer',
                        subscription: this.prevSubId,
                        toSubscription: this.nextSubId
                    };
                    let data: Record<string, any> = {};
                    data.items = [planData];
                    data.amount = '0.00';
                    data.currency = this.refundArr[0].currency;
                    try {

                        let res = await transferSubscription( data );
                        await this.$router.push({
                            path: `/user/complete/`,
                            query: {
                                mode: 'transfer',
                                id: res.id
                            }
                        });

                    } catch ( err ) {

                        console.log( err );
                        let symbol = ( err as AxiosError ).response?.data.error.symbol;
                        let reason = typeof ( err as AxiosError ).response?.data.error.metadata.reason !== 'undefined' ? ( err as AxiosError ).response?.data.error.metadata.reason : '';
                        let key = '';
                        if ( symbol === 'violate_subscribe_restriction' ) {

                            if ( reason === 'subscriptionMaxPurchaseCycles' ) {

                                key = 'errors.violate_cycle_limitation';

                            }

                        } else if ( symbol === 'cannot_cancel_subscription' ) {

                            if ( reason === 'subscription is refunding' ) {

                                key = 'subscription is refunding';

                            }

                        } else if ( symbol === 'upgrade_maintenance' ) {

                            key = 'errors.service_maintenance';

                        }
                        this.loading = false;
                        unfoldError( key, 10000 );

                    } finally {

                        this.isCanceling = false;

                    }
                    return;

                }

                this.isCanceling = true;
                this.loading = true;
                this.chooseRadioObj = {
                    id: sub.id,
                    reason: this.downloadOne
                };

                if ( this.cancelMethod === 'Paypal' ) {

                    if ( this.paypalDetails.payerAccount.value === '' ) {

                        this.showPaypalDialog = true;
                        return;

                    }

                    this.chooseRadioObj.manualRefundInfo = {
                        method: 'paypal',
                        account: this.paypalDetails.payerAccount.value
                    };

                } else if ( this.cancelMethod === 'Payoneer' ) {

                    this.chooseRadioObj.manualRefundInfo = {
                        method: 'payoneer',
                        number: this.payoneerDetails.payoneerCard.value,
                        holderName: this.payoneerDetails.payoneerName.value
                    };

                }

                this.chooseRadioObj = JSON.parse( JSON.stringify( this.chooseRadioObj ));

                try {

                    if ( this.dialogConfirmShow ) {

                        ( this.$refs.confirmDialog as any )?.disabledBtn();

                    }
                    if ( isTraffic ) {

                        this.chooseRadioObj.id = this.traffic_package_id;
                        await deleteTrafficProduct( this.chooseRadioObj );

                    } else {

                        await deleteProduct( this.chooseRadioObj as any );

                    }

                    await this.$router.push({

                        path: '/user/cancel-plan/complete/',
                        query: {
                            plan_name: sub.plan.title,
                            type: isTraffic ? 'traffic' : 'storage'
                        }

                    });

                } catch ( err ) {

                    if ( this.dialogConfirmShow && ( this.$refs.confirmDialog as any )?.confirmDisabled ) {

                        ( this.$refs.confirmDialog as any )?.enabledBtn();

                    }
                    const symbol = ( err as AxiosError ).response?.data.error.symbol;
                    const reason = ( err as AxiosError ).response?.data?.error?.metadata?.reason;
                    if (( err as AxiosError ).response?.data.error.symbol === 'cannot_update_refund' ) {

                        unfoldError( 'errors.cannot_update_refund' );
                        this.showPaypalDialog = false;

                    } else if (( err as AxiosError ).response?.data.error.symbol === 'payer_account_required' ) {

                        this.showPaypalDialog = true;
                        // if ( config.oem !== 'reolink' ) {

                        this.cancelMethod = 'Paypal';

                        // } else {

                        //     this.$nextTick(() => {

                        //         this.$refs.paypalDialog.disabledBtn();

                        //     });

                        // }

                    } else if (( err as AxiosError ).response?.data.error.symbol === 'cannot_cancel_subscription' ) {

                        this.showPaypalDialog = false;
                        let reason = ( err as AxiosError ).response?.data.error?.metadata?.reason ?? '';
                        if ( reason === 'subscription inactive' ) {

                            unfoldError( 'cancel_plan.cancelled', 10000 );
                            setTimeout(() => {

                                this.$router.push({ path: '/user/dashboard' }).catch( console.error );

                            }, 5000 );

                        } else if ( reason === 'subscription is refunding' ) {

                            unfoldError( 'errors.sub_refunding', 10000 );

                        } else if ( reason === 'service is refunding' ) {

                            unfoldError( 'errors.service_refunding', 10000 );

                        }
                        else {

                            unfoldError( 'errors.server_error', 10000 );

                        }

                    } else if (( err as AxiosError ).response?.data.error.symbol === 'cannot_cancel_package' ) {

                        let reason = ( err as AxiosError ).response?.data.error.metadata.reason ?? '';

                        // package inactive
                        if ( reason === 'package inactive' ) {

                            unfoldError( 'errors.package_inactive', 10000 );
                            setTimeout(() => {

                                this.$router.push({ path: '/user/dashboard/?mode=view' }).catch( console.error );

                            }, 5000 );

                        } else if ( reason === 'package is refunding' ) {

                            unfoldError( 'errors.order_not_refundable', 10000 );

                        }

                    } else if (( err as AxiosError ).response?.data.error.symbol === 'duplicate_manual_refund' ) {

                        unfoldError( 'errors.order_not_refundable', 10000 );

                    } else if (( err as AxiosError ).response?.data.error.symbol === 'upgrade_maintenance' ) {

                        unfoldError( 'errors.service_maintenance', 10000 );

                    } else if ( symbol === 'usr_locked' ) {

                        if ( reason === 'user locked for auto-renew' ) {

                            unfoldError( 'errors.user_locked_for_auto-renew' );

                        } else {

                            unfoldError( 'errors.usr_locked' );

                        }

                    } else {

                        unfoldError( 'errors.server_error' );
                        this.showPaypalDialog = false;
                        this.showTips = false;
                        this.loading = false;
                        console.error( err );

                    }

                } finally {

                    this.isCanceling = false;

                }

            }

        },
        async initPlan (): Promise<void> {

            try {

                let data = await getCloudProductLists({ lang: this.$i18n.locale }, 'all' );
                this.cloudProductLists = data.cloudProductLists;
                this.sub = await getSubscriptionById( this.prevSubId );

                if ( typeof this.cloudProductLists.plans[this.sub.plan] === 'undefined' ) {

                    let planDetails = await getPlanById( this.sub.plan );
                    this.sub.plan = planDetails.plan;
                    this.sub.plan.title = planDetails.series.i18n.name;
                    this.cloudProductLists.plans[this.sub.plan] = planDetails.plan;
                    this.cloudProductLists.plans[`${this.sub.plan}`].style['plan.display_color'] = planDetails.series.style['series.display_color'];

                } else {

                    this.sub.plan = this.cloudProductLists.plans[this.sub.plan];

                }
                if ( this.sub.nextSwitchableAt === 0 || new Date().getTime() > this.sub.nextSwitchableAt ) {

                    this.switchable = true;

                }
                this.showContent = true;
                this.deviceList = await getDeviceTotal();
                this.deviceList = this.deviceList.filter( item => this.cloudProductLists.cloudModels.indexOf( item.modelTitle ) !== -1 );

                let subData = await getSubscriptions();
                for ( let sub of subData.items as Array<Record<string, any>> ) {

                    if ( sub.id !== this.prevSubId && sub.status === 'active' ) {

                        if ( typeof this.cloudProductLists.plans[`${sub.plan}`] === 'undefined' ) {

                            let planDetails = await getPlanById( sub.plan );
                            sub.plan = planDetails.plan;
                            sub.plan.title = planDetails.series.i18n.name;
                            this.cloudProductLists.plans[`${sub.plan}`] = planDetails.plan;
                            this.cloudProductLists.plans[`${sub.plan}`].style['plan.display_color'] = planDetails.series.style['series.display_color'];

                        } else {

                            sub.plan = this.cloudProductLists.plans[`${sub.plan}`];

                        }
                        let deviceList: any[] = [];
                        let deviceUidList: any[] = [];
                        for ( let device of this.deviceList ) {

                            if ( device.subscription === sub.id ) {

                                deviceUidList.push( device.uid );
                                if ( device.status === 'associated' ) {

                                    deviceList.push( device );

                                }

                            }

                        }
                        let size = '0.00';
                        let usedSpace = 0;
                        if ( deviceUidList.length !== 0 ) {

                            try {

                                const usage = await getUserUsage( deviceUidList );

                                for ( let item of usage.items ) {

                                    usedSpace += item.usedSpace;

                                }

                                /**
                            * 已使用的容量
                            */
                                usedSpace = usedSpace > sub.plan['style']['cloud_storage.space_capacity'] ? sub.plan['style']['cloud_storage.space_capacity'] : usedSpace;
                                size = ( usedSpace / 1024 / 1024 / 1024 ).toFixed( 2 );

                                if ( size === '0.00' && usedSpace ) {

                                    size = '0.01';

                                }

                            } catch ( err ) {

                                console.log( err );

                            }

                        }

                        let maxSpace = ( sub.plan['style']['cloud_storage.space_capacity'] / 1024 / 1024 / 1024 ).toFixed( 2 );
                        sub.usedSpace = size;
                        sub.maxSpace = maxSpace;
                        sub.maxCamera = sub.plan.style['cloud_storage.max_device_quantity'];
                        sub.deviceList = deviceList;
                        if ( Number( sub.plan.cycle.salePrice ) !== 0 ) {

                            this.transferableSub.push( sub );

                        }

                    }

                }

                let refundData = await previewRefundInfo( this.sub.id );
                this.refundArr = refundData.refund;
                this.nextSubId = this.transferableSub.length > 0 ? this.transferableSub[0].id : 0;

            } catch ( err ) {

                this.loading = true;
                let symbol = ( err as AxiosError ).response?.data.error.symbol;

                if ( symbol === 'cannot_cancel_subscription' ) {

                    let reason = typeof ( err as AxiosError ).response?.data.error.metadata.reason !== 'undefined' ? ( err as AxiosError ).response?.data.error.metadata.reason : '';

                    // subscription inactive
                    if ( reason === 'subscription inactive' ) {

                        unfoldError( 'cancel_plan.cancelled', 10000 );
                        setTimeout(() => {

                            this.$router.push({ path: '/user/dashboard' }).catch( console.error );

                        }, 5000 );

                    } else if ( reason === 'subscription is refunding' ) {

                        unfoldError( 'subscription is refunding', 10000 );

                    }

                } else if ( symbol === 'order_not_refundable' ) {

                    unfoldError( 'errors.order_not_refundable', 10000 );

                } else {

                    this.loading = false;
                    unfoldError( 'errors.server_error', 10000 );

                }
                nprogress.done();

            }

        },
        async initTraffic (): Promise<void> {

            try {

                let refundData = await previewTrafficRefundInfo( this.traffic_package_id );
                this.refundArr = refundData.refund;

            } catch ( err ) {

                this.loading = true;
                const symbol = ( err as AxiosError ).response?.data.error.symbol;
                if ( symbol === 'cannot_cancel_package' ) {

                    let reason = ( err as AxiosError ).response?.data.error.metadata.reason ?? '';

                    // package inactive
                    if ( reason === 'package inactive' ) {

                        unfoldError( 'cancel_plan.cancelled', 10000 );
                        setTimeout(() => {

                            this.$router.push({ path: '/user/dashboard/?mode=view' }).catch( console.error );

                        }, 5000 );

                    } else if ( reason === 'package is refunding' ) {

                        unfoldError( 'errors.order_not_refundable', 10000 );

                    } else {

                        unfoldError( 'errors.server_error', 10000 );

                    }

                } else if ( symbol === 'order_not_refundable' ) {

                    unfoldError( 'errors.order_not_refundable', 10000 );

                } else if ( symbol === 'upgrade_maintenance' ) {

                    unfoldError( 'errors.service_maintenance', 10000 );

                } else {

                    this.loading = false;
                    unfoldError( 'errors.server_error', 10000 );

                }

            }

            let { plan } = await getTrafficById( this.trafficPlanId, this.$i18n.locale );
            plan.title = plan.i18n.display_name;
            this.sub.plan = plan;
            this.showContent = true;

        },
        dialogMounted ( ref: any ): void {

            if ( this.dialogStack.length === 0 ) {

                $( $( 'html' )[0] ).toggleClass( 'dialogActived' );

            }
            this.dialogStack.push( ref );

        },
        dialogDestroyed ( ): void {

            this.dialogStack.pop();
            if ( this.dialogStack.length === 0 ) {

                $( $( 'html' )[0] ).toggleClass( 'dialogActived' );

            }

        },
        showFormError ( cancelMethod: string ): boolean {

            const group = cancelMethod === 'Payoneer' ? this.payoneerDetails : this.paypalDetails;
            let showError = false;
            for ( let key in group ) {

                let item = group[key];
                if ( item.required ) {

                    if ( !item.value || item.value === '' ) {

                        item.error = this.$tc( 'errors.field_required' );
                        showError = true;

                    }
                    if ( item.value.length > 255 ) {

                        item.error = this.$tc( 'errors.common_length_error', undefined, { option: item.placeholder });
                        showError = true;

                    }

                }

            }
            return showError;

        },
        showConfirmDialog (): void {

            if ( this.showPaypalDialog && this.showFormError( this.cancelMethod )) {

                return;

            }
            this.dialogConfirmShow = true;
            this.showPaypalDialog = false;

        },
        cancel (): void {

            this.showPaypalDialog = false;
            this.dialogConfirmShow = false;
            this.loading = false;
            this.cancelMethod = '';
            this.paypalDetails.payerAccount.value = '';
            this.payoneerDetails.payoneerCard.value = '';
            this.payoneerDetails.payoneerName.value = '';

        },
        async confirmInputPaypal( account: string ) {

            this.paypalDetails.payerAccount.value = account;
            await this.continueCancel();

        }

    },
    watch: {
        cancelWay: {
            handler ( newVal ) {

                if ( newVal === 'transfer' ) {

                    if ( this.isMobile ) {

                        this.carouselItems = 1;

                    } else {

                        this.carouselItems = 2;

                    }
                    this.$nextTick(() => {

                        ( this.$refs.planChooseCarousel as any ).init();

                    });

                }

            },
            immediate: true
        },
        nextSubId: {
            handler ( newVal ) {

                for ( let sub of this.transferableSub ) {

                    if ( sub.id === newVal ) {

                        this.nextSub = sub;

                    }

                }

            },
            immediate: true
        },
        cancelMethod ( newVal ) {

            if ( newVal === 'Payoneer' ) {

                this.paypalDetails.payerAccount.required = true;
                this.paypalDetails.payerAccount.error = false;

            } else {

                this.payoneerDetails.payoneerCard.required = true;
                this.payoneerDetails.payoneerName.required = true;
                this.payoneerDetails.payoneerCard.error = false;
                this.payoneerDetails.payoneerName.error = false;

            }

            if (( this.$refs.paypalDialog as any )?.confirmDisabled ) {

                ( this.$refs.paypalDialog as any )?.enabledBtn();

            }

        }
    },
    computed: {

        highLight () {

            let { path } = this.$route;
            return path === '/user/cancel-plan/complete/' ? 1 : 0;

        },

        message (): IPlanMessage[] {

            let sub = this.sub;
            let refundArr = this.refundArr;
            let result = [
                {
                    label: this.$tc( 'cancel_plan.account' ),
                    texts: [
                        this.address
                    ],
                    red: true
                }

            ];
            if ( this.mode === 'traffic' ) {

                result.push({
                    label: this.$tc( 'cancel_plan.current_plan' ),
                    texts: [
                        this.sub.plan.title
                    ],
                    red: true
                });

            } else {

                result.push({
                    label: this.$tc( 'cancel_plan.current_plan' ),
                    texts: [
                        this.$options.filters!.planName( sub.plan )
                    ],
                    red: true
                });

            }

            if ( refundArr && refundArr.length > 0 ) {

                let refundText = refundArr.map(( item ) => {

                    return `${item.currency} ${item.value}`;

                }).join( ' + ' );

                result.push({

                    label: this.$tc( 'cancel_plan.refund' ),
                    texts: [
                        refundText
                    ],
                    red: true

                });

            }

            return result;

        },

        switchPlanPath (): string {

            return `/user/subscribe-plan/update-cloud?ps_id=${this.prevSubId}`;

        },

        isMobile(): boolean {

            return this.$store.getters.isMobile;

        },
        lang(): string  {

            return this.$store.getters.lang;

        },
        client (): string {

            return this.config.oem;

        },
        notRichPlan (): boolean {

            const series = this.cloudProductLists.planSeries?.[this.sub.plan.seriesKey];
            return series?.category !== ESeriesCategory.CLOUD_RICH_NOTIFICATION_PLAN;

        }

    }

});
</script>

<style lang="less" scoped>
    .reo-dialog /deep/ .reo-dialog-inner{
        width: 6.4rem;
        @media @mobile{
            width:100%;
        }
    }
    .reo-dialog.paypal-dialog.confirm{
        & /deep/ .reo-dialog-inner{
            min-height: unset;
        }
    }
    .paypal-dialog .paypal-dialog-title{
        text-align: left;
        font-size: .2rem;
        line-height: 1.4;
        color:#333;
        margin-top: .5rem;
        padding:0 .4rem;
        font-weight: 500;
        @media @mobile{
            font-size: .28rem;
        }
    }
    .paypal-dialog .paypal-dialog-container{
        padding:0 .4rem;
    }
    .paypal-dialog .paypal-dialog-note{
        font-size: 0.24rem;
        margin-top: .2rem;
        margin-bottom: .3rem;
        &.confirm{
            margin-bottom:.16rem;
            @media @mobile{
                margin-bottom: .12rem;
            }
        }
        @media @mobile{
            width:unset;
            padding-right:.3rem;
        }
        & /deep/ .note{
            font-size: .18rem;
            text-align: left;
            margin-bottom: 0.2rem;
            line-height: 1.2;
            &:last-child{
                margin-bottom: 0;
            }
            @media @mobile {
                font-size: .26rem;
                margin-bottom:.12rem;
            }
        }
    }
    .paypal-dialog .paypal-dialog-inner {
        font-size: 0.24rem;

        @media @mobile{
            width:unset;
            padding-right:.3rem;
        }
        .reasons-box{
            text-align: left;
        }
        .choose-methods{
            margin-bottom: .1rem;
            @media @mobile{
                margin-bottom: .16rem;
            }
        }
        .account-box{
            display: flex;
            flex-direction: column;
            div{
                margin-bottom: .15rem;
                overflow-wrap: anywhere;

            }
            label,span{
                font-size: .18rem;
                font-weight: 500;
                @media @mobile{
                    font-size: .26rem;
                }
            }
            .value{
                max-height: 1rem;
                overflow-y: auto;
                overflow-y: overlay;
                display: block;
                @media @mobile{
                    max-height: 2rem;
                }
            }
        }
        .info-grey{
            font-size: .18rem;
            line-height: 1.4;
            @media @mobile{
                font-size: .26rem;
            }
        }

    }
    .paypal-dialog .warning-tip{
        padding:0 .4rem;
        font-size: .18rem;
        text-align: left;
        @media @mobile{
            font-size: .26rem;
            margin:0 !important;
        }
    }
    .cancelplan-root {
        margin: auto;
        max-width: 1200px;
        padding: .8rem 0;
        border-radius: 0.2rem;
        background-color:#fff;
        @media @mobile{
            background-color: transparent;
        }
        .root-container{
            @media @pc{
                margin: 0 2.2rem;
            }
        }
        .content-top {
            text-align: center;
            h1 {
                padding-bottom: .4rem;
                line-height: 1.2;
                font-weight: 700;
                font-size: 0.36rem;
                color: #333;
            }
        }

    }
    .step-com{
        margin-bottom: .48rem;
    }
    .middle-content {
        margin-bottom: .48rem;
        & /deep/ .plan-message{
            @media @pc{
                padding:.32rem .56rem;
            }
            tr+tr td{
                padding-top: 0.16rem;
                @media @mobile{
                    padding-top: 0.2rem;
                }
            }
        }
    }
    .package {
        font-weight: 500;
        font-size: 0.22rem;
        line-height: 1.4;
        margin-bottom: 0.16rem;
    }

    .package.canc-plan{
        margin-bottom: 0.1rem;
        font-weight: 400;
        font-size: 0.16rem;
        display: flex;
        .benefit{
            padding-right:0.15rem;;
        }
        &:nth-child(2){
            margin-bottom: .08rem;
        }
    }
    .middle-cancel-ways{
        margin-bottom: .48rem;
        .planCarousel{
            margin-top: .16rem;
        }
        .planBox{
            display: flex;
            // box-sizing: border-box;
            border:1px solid #ccc;
            padding:.3rem .24rem;
            border-radius: .08rem;
            .planContainer{
                font-size: .16rem;
                margin-left: .16rem;
                @media @mobile {
                    font-size:.26rem;
                    color:#333;
                    font-weight: 500;
                    span{
                        font-weight: 400;
                    }
                }
                &>div{
                    margin-bottom: .16rem;
                }
                label{
                    font-weight: 500;
                }
                .cloud-title{
                    display: flex;
                    align-items: center;
                    i{
                        display: inline-block;
                        width: .14rem;
                        height: .14rem;
                        border-radius: 50%;
                        margin-right: .1rem;
                        vertical-align: bottom;
                        position: relative;
                        @media @mobile{
                            width: .24rem;
                            height: .24rem;
                        }
                    }
                    @media @mobile {
                        line-height: .34rem;
                        margin-top: 0.05rem;
                    }
                }
            }

        }
    }
    .middle-before {
        padding: .3rem;
        background: #F7F8F9;
        border-radius: .08rem;
        margin-bottom: .48rem;
    }
    .benefit-box {
        margin-left:0.2rem;
        padding-bottom: 0.1rem;
        .info-grey {
            color: #333;
            font-size: 0.16rem;
            font-weight: 400;
            line-height: 1.5;
        }
        .three-service+.three-service{
            margin-top: 0.08rem;
        }
    }
    .middle-reasons {
        margin-bottom: 0.16rem;
        padding-bottom: 0.48rem;
        border-bottom: solid 0.01rem #dddddd;
        .package {
            &::before {
                content: '*';
                color: #e74330;
                margin-right: 0.04rem;
                font-size: 0.16rem;
            }
        }
    }
    .reasons-box {
       .info-grey {
            color: #333;
            font-size: 0.16rem;
            font-weight: 400;
            padding-bottom: 0.04rem;
            display: inline-block;
        }
    }
    .reasons-right {
        margin-left:0.4rem;
        position: relative;
        top:0.02rem;
        a {
            .text {
                font-weight: 500;
                font-size: 0.16rem;
            }
        }
    }
    .choose-checkbox {
        // display: flex;
        &:nth-child(n+2){
            margin-top: .12rem;
        }
    }
    .middle-text {
        p {
            color: #333;
            font-size: 0.16rem;
            font-weight: 400;
        /deep/ a {
            color: @theme;
            cursor: pointer;
            font-size: .16rem;
        }
      }
    }
    .check-ok {
        margin: 0.16rem 0 0.4rem 0;
        display: flex;
        align-items: center;
        .check-box{
            display: inline-flex;
            margin-right: 0.1rem;
        }
        span {
            font-weight: 500;
            font-size: 0.16rem;
            vertical-align: middle;
        }
    }
    .button-box {
        margin-bottom: 0.7rem;
        text-align: center;
        display: flex;
        justify-content: center;
        gap: 0.2rem;
        .ui-button+.ui-button{
            margin-left: 0.2rem;
        }
    }
    @media @mobile{
        .cancelplan-root {
            padding: 0 .3rem;
            .root-container{
               width:100%;
            }
            .content-top {
                h1 {
                    margin: .6rem 0 .4rem;
                    font-weight: 500;
                    font-size: 0.52rem;
                    color: #333;
                    padding:0;
                }
            }
            .step-com{
                margin-bottom: .6rem;
                .steps-item{
                    width:0.44rem;
                    padding: 0 0.44rem;
                }
            }
        }
        .middle-content {
            padding-bottom: 0.8rem;
            margin-bottom:0;
        }
        .package {
            font-weight: 500;
            font-size: 0.36rem;
            margin-bottom: 0.3rem;
        }
        .package.canc-plan{
            margin-bottom: 0.12rem;
            font-weight: 400;
            font-size: 0.26rem;
            display: flex;
            .benefit{
                padding-right:0.15rem;
            }
            &:nth-child(2){
                margin-bottom: .12rem;
            }
        }

        .middle-before {
            padding: .4rem .3rem;
            margin-bottom: .8rem;
        }
        .benefit-box {
            line-height: 1.4;
            margin-left:0.2rem;
            padding-bottom: 0.12rem;
            .info-grey {
                color: #333333;
                font-size: 0.26rem;
                font-weight: 400;
            }
            .three-service+.three-service{
                margin-top: 0.1rem;
            }
        }
        .middle-reasons {
            padding-bottom: .6rem;
            margin-bottom: .2rem;
            border-bottom: solid 0.01rem #dddddd;
            .package {
                &::before {
                    content: '*';
                    color: #e74330;
                    margin-right: 0.04rem;
                    font-size: 0.28rem;
                }
            }
        }
        .reasons-box {
            .info-grey {
                color: #333333;
                font-size: 0.26rem;
                font-weight: 400;
                // margin-left: 0.1rem;
                // margin-bottom: 0.3rem;
                // line-height: 2;
                display: inline-block;

            }
        }
        .reasons-right {
            margin-left:0;
            position: relative;
            margin-left:0.2rem;
            a {
                .text {
                    font-weight: 500;
                    font-size: 0.26rem;
                }
            }
        }
        .choose-checkbox {
            // display: flex;
            // flex-wrap: nowrap;
            &:nth-child(n+2){
                margin-top: .3rem;
            }
            // margin-bottom: .3rem;
            .circle {
                line-height: 0.4rem;
            }
        }
        .middle-text {
            p {
                color: #333;
                font-size: 0.26rem;
                font-weight: 400;
                /deep/ a.ui-link {
                    color: @theme;
                    cursor: pointer;
                    font-weight: 400;
                    font-size: .26rem;
                }
            }
        }
        .check-ok {
            margin: 0.24rem 0 0.56rem 0;
            span.red{
                margin-left:0.1rem;
            }
            span {
                font-weight: 500;
                font-size: 0.26rem;
            }
        }
        .button-box {
            display: flex;
            padding: 0 0 1rem 0;
            margin:0;
            flex-direction: column;
            .ui-button{
                width: 100%;
            }
            .ui-button+.ui-button{
                margin: 0.2rem 0 0;
            }
        }
    }

    .countryBtn{
        @media @mobile{
            display: block;
        }
        font-size: .16rem;
        color:@theme;
        line-height: 1.2;
        font-weight: 500;
        cursor: pointer;
        span{
            transition: all .2s linear;
            margin-left: 8px;
        }
        &:hover span{
            margin-left: 16px;
        }
        @media @mobile{
            font-size:.28rem;
        }
    }
    .reo-vfx-area {
        display: inline-block;
        width: 100%;
        margin-bottom: 20px;

        &.half-width {
            width: calc((100% - 20px) / 2);

            &:nth-child(even) {
                margin-left: 20px;
            }
        }

        .reo-vfx-box {
            position: relative;
            display: block;
        }

        .reo-vfx-input {
            border: 1px solid #ccc;
            font-weight: 500;
            color: #333;
            font-size: 16px;
            padding: 0 20px;
            width: 100%;
            height: 48px;
            line-height: 48px;
            border-radius: 6px;
            box-sizing: border-box;
            box-shadow: none;
            outline: none;
            box-shadow: 0px 0px 6px 2px rgba(0, 0, 0, 0.14);
            border: 1px solid transparent;
            @media @mobile {
                font-size: .28rem;
            }

            &:focus {
                border-color: @theme;
            }
            &.error {
                border-color: #e74330;
            }

        }

        .reo-vfx-placeholder {
            white-space: nowrap;
            transition: all 0.3s ease-in-out;
            position: absolute;
            top: 50%;
            left: 20px;
            transform: translateY(-50%);
            pointer-events: none;
            font-size: 16px;
            font-weight: 500;
            display: inline-block;
            padding: 0 4px;
            color: #777;
            @media @mobile {
                font-size: .28rem;
            }
        }

        .reo-vfx-input:focus ~ .reo-vfx-placeholder,
        .reo-vfx-input:not(.empty) ~ .reo-vfx-placeholder {
            top: 0;
            font-size: 14px;
            background-color: #fff;
            @media @mobile {
                font-size: .24rem;
            }
        }

        .reo-vfx-input:focus ~ .reo-vfx-placeholder {
            color: @theme;
        }

        .reo-vfx-required-flag {
            position: absolute;
            top: 0;
            right: -10px;
            color: #e74330;
            font-weight: 500;
            font-size: 18px;
        }

        .input-tip {
            font-size: 14px;
            color: #777;
            font-weight: 500;
            line-height: 1.2;
            margin-top: 16px;
        }
    }
    @media @mobile {
        .reo-vfx-area.half-width[name='postalCode'] {
            margin-left: 0;
            width: 100%;
        }
    }

    /deep/ .ui-link .text{
        vertical-align: top;
    }

    /deep/ .radio-wrap{
        white-space: normal;
    }

    .ui-link{
        display: inline-flex;
        align-items: center;
    }
</style>
